import React from 'react';
import { Button } from '@abyss/web/ui/Button';
import { Heading } from '@abyss/web/ui/Heading';
import { Layout } from '@abyss/web/ui/Layout';
import { Router } from '@abyss/web/ui/Router';

export const HelloAbyss = () => {
  return (
    <React.Fragment>
      <Router.MetaTags title="Hello" />
      <Layout.Stack alignLayout="center">
        <Heading textAlign="center">Hello!</Heading>
        <Button href="/">Go back</Button>
      </Layout.Stack>
    </React.Fragment>
  );
};
